"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TMDB = exports.WatchProvidersAPI = exports.TVEpisodeGroupsAPI = exports.TVSeasonsAPI = exports.TVEpisodesAPI = exports.TVShowsAPI = exports.TrendingAPI = exports.SearchAPI = exports.ReviewsAPI = exports.PeopleAPI = exports.NetworksAPI = exports.MoviesAPI = exports.ListsAPI = exports.KeywordsAPI = exports.GuestSessionsAPI = exports.GenresAPI = exports.FindAPI = exports.DiscoverAPI = exports.CreditsAPI = exports.ConfigurationAPI = exports.CompaniesAPI = exports.CollectionsAPI = exports.ChangesAPI = exports.CertificationsAPI = exports.AuthenticationAPI = exports.AccountAPI = void 0;
// Isolated APIs
var account_1 = require("./apis/account");
Object.defineProperty(exports, "AccountAPI", { enumerable: true, get: function () { return account_1.AccountAPI; } });
var authentication_1 = require("./apis/authentication");
Object.defineProperty(exports, "AuthenticationAPI", { enumerable: true, get: function () { return authentication_1.AuthenticationAPI; } });
var certifications_1 = require("./apis/certifications");
Object.defineProperty(exports, "CertificationsAPI", { enumerable: true, get: function () { return certifications_1.CertificationsAPI; } });
var changes_1 = require("./apis/changes");
Object.defineProperty(exports, "ChangesAPI", { enumerable: true, get: function () { return changes_1.ChangesAPI; } });
var collections_1 = require("./apis/collections");
Object.defineProperty(exports, "CollectionsAPI", { enumerable: true, get: function () { return collections_1.CollectionsAPI; } });
var companies_1 = require("./apis/companies");
Object.defineProperty(exports, "CompaniesAPI", { enumerable: true, get: function () { return companies_1.CompaniesAPI; } });
var configuration_1 = require("./apis/configuration");
Object.defineProperty(exports, "ConfigurationAPI", { enumerable: true, get: function () { return configuration_1.ConfigurationAPI; } });
var credits_1 = require("./apis/credits");
Object.defineProperty(exports, "CreditsAPI", { enumerable: true, get: function () { return credits_1.CreditsAPI; } });
var discover_1 = require("./apis/discover");
Object.defineProperty(exports, "DiscoverAPI", { enumerable: true, get: function () { return discover_1.DiscoverAPI; } });
var find_1 = require("./apis/find");
Object.defineProperty(exports, "FindAPI", { enumerable: true, get: function () { return find_1.FindAPI; } });
var genres_1 = require("./apis/genres");
Object.defineProperty(exports, "GenresAPI", { enumerable: true, get: function () { return genres_1.GenresAPI; } });
var guest_sessions_1 = require("./apis/guest-sessions");
Object.defineProperty(exports, "GuestSessionsAPI", { enumerable: true, get: function () { return guest_sessions_1.GuestSessionsAPI; } });
var keywords_1 = require("./apis/keywords");
Object.defineProperty(exports, "KeywordsAPI", { enumerable: true, get: function () { return keywords_1.KeywordsAPI; } });
var lists_1 = require("./apis/lists");
Object.defineProperty(exports, "ListsAPI", { enumerable: true, get: function () { return lists_1.ListsAPI; } });
var movies_1 = require("./apis/movies");
Object.defineProperty(exports, "MoviesAPI", { enumerable: true, get: function () { return movies_1.MoviesAPI; } });
var networks_1 = require("./apis/networks");
Object.defineProperty(exports, "NetworksAPI", { enumerable: true, get: function () { return networks_1.NetworksAPI; } });
var people_1 = require("./apis/people");
Object.defineProperty(exports, "PeopleAPI", { enumerable: true, get: function () { return people_1.PeopleAPI; } });
var reviews_1 = require("./apis/reviews");
Object.defineProperty(exports, "ReviewsAPI", { enumerable: true, get: function () { return reviews_1.ReviewsAPI; } });
var search_1 = require("./apis/search");
Object.defineProperty(exports, "SearchAPI", { enumerable: true, get: function () { return search_1.SearchAPI; } });
var trending_1 = require("./apis/trending");
Object.defineProperty(exports, "TrendingAPI", { enumerable: true, get: function () { return trending_1.TrendingAPI; } });
var tv_shows_1 = require("./apis/tv-shows");
Object.defineProperty(exports, "TVShowsAPI", { enumerable: true, get: function () { return tv_shows_1.TVShowsAPI; } });
var tv_episodes_1 = require("./apis/tv-episodes");
Object.defineProperty(exports, "TVEpisodesAPI", { enumerable: true, get: function () { return tv_episodes_1.TVEpisodesAPI; } });
var tv_seasons_1 = require("./apis/tv-seasons");
Object.defineProperty(exports, "TVSeasonsAPI", { enumerable: true, get: function () { return tv_seasons_1.TVSeasonsAPI; } });
var tv_episode_groups_1 = require("./apis/tv-episode-groups");
Object.defineProperty(exports, "TVEpisodeGroupsAPI", { enumerable: true, get: function () { return tv_episode_groups_1.TVEpisodeGroupsAPI; } });
var watch_providers_1 = require("./apis/watch-providers");
Object.defineProperty(exports, "WatchProvidersAPI", { enumerable: true, get: function () { return watch_providers_1.WatchProvidersAPI; } });
// Wrapper
var wrapper_1 = require("./apis/wrapper");
Object.defineProperty(exports, "TMDB", { enumerable: true, get: function () { return wrapper_1.Wrapper; } });
// Exceptions
__exportStar(require("./exceptions"), exports);
// Types
__exportStar(require("./types/index"), exports);
__exportStar(require("./apis/account/types"), exports);
__exportStar(require("./apis/authentication/types"), exports);
__exportStar(require("./apis/certifications/types"), exports);
__exportStar(require("./apis/changes/types"), exports);
__exportStar(require("./apis/collections/types"), exports);
__exportStar(require("./apis/companies/types"), exports);
__exportStar(require("./apis/configuration/types"), exports);
__exportStar(require("./apis/credits/types"), exports);
__exportStar(require("./apis/discover/types"), exports);
__exportStar(require("./apis/find/types"), exports);
__exportStar(require("./apis/genres/types"), exports);
__exportStar(require("./apis/guest-sessions/types"), exports);
__exportStar(require("./apis/keywords/types"), exports);
__exportStar(require("./apis/lists/types"), exports);
__exportStar(require("./apis/movies/types"), exports);
__exportStar(require("./apis/networks/types"), exports);
__exportStar(require("./apis/people/types"), exports);
__exportStar(require("./apis/reviews/types"), exports);
__exportStar(require("./apis/search/types"), exports);
__exportStar(require("./apis/trending/types"), exports);
__exportStar(require("./apis/tv-episode-groups/types"), exports);
__exportStar(require("./apis/tv-episodes/types"), exports);
__exportStar(require("./apis/tv-seasons/types"), exports);
__exportStar(require("./apis/tv-shows/types"), exports);
__exportStar(require("./apis/watch-providers/types"), exports);
